module.exports = __webpack_public_path__ + "img/consult_info5.fc2fa32d.png";